import { combineReducers } from 'redux';
import keys from 'lodash/keys';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import mapValues from 'lodash/mapValues';
import * as InspectionActionTypes from '../inspection/inspection.actionTypes';

const allIds = (state = [], action) => {
  switch (action.type) {
    case InspectionActionTypes.READ_INSPECTION_SCHEMAS_SUCCESS:
      return action.response.result;
    default:
      return state;
  }
};

const byId = (state = {}, action) => {
  let formSchema = null;
  if (action.response && action.response.entities) {
    if (action.response.entities.formSchema) {
      formSchema = action.response.entities.formSchema;
    } else if (action.response.entities.formSchemaSchema) {
      formSchema = mapValues(
        action.response.entities.formSchemaSchema,
        schema => schema.formSchema
      );
    }
    if (formSchema) {
      if (action.response.method && action.response.method === 'DELETE') {
        return omit(state, keys(formSchema));
      }
      return merge({}, state, formSchema);
    }
  }
  return state;
};

const reducer = combineReducers({
  allIds,
  byId,
  //isFetching,
  //errorMessage,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/formSchema/formSchema.reducer.js